import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes, Outlet } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

// Essential components (eagerly loaded)
import Home from './component/pages/home/Home';
import Header from './component/header/Header';
import Footer from './component/footer/Footer';
import Upheader from './component/upheader/Upheader';
import Clint from './component/clint/Clint';
import ScheduleMeeting from './component/schedulemeeting/ScheduleMeeting';
import WhatsAppChat from './component/whatsAppchat/WhatsAppChat';
// Lazy-loaded components
const Product = lazy(() => import('./component/pages/our-product/Product'));
const About = lazy(() => import('./component/pages/about/About'));
const Partner = lazy(() => import('./component/partners/Partner'));
const Inqury = lazy(() => import('./component/pages/inqury/Inqury'));
const Contact = lazy(() => import('./component/pages/contact/Contact'));
const Csr = lazy(() => import('./component/quick/Csr'));
const Careers = lazy(() => import('./component/quick/Careers'));
const Investor = lazy(() => import('./component/quick/Investor'));
const Faq = lazy(() => import('./component/quick/Faq'));
const PrivacyNotice = lazy(() => import('./component/quick/Privacy'));
const CookiePolicy = lazy(() => import('./component/quick/Cookie'));
const Accessibility = lazy(() => import('./component/quick/Accessibility'));
const Disclaimer = lazy(() => import('./component/quick/Disclaimer'));
const SecurityPolicy = lazy(() => import('./component/quick/Security'));
const CaliforniaNotice = lazy(() => import('./component/quick/California'));

const Baselayout = () => {
  return (
    <>
      <Upheader />
      <Header />

      <ScheduleMeeting />
      <WhatsAppChat />
      <Outlet />
      <Clint />
      <Footer />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Suspense fallback={<div className="loading-spinner">Loading...</div>}>
          <Routes>
            <Route path="/" element={<Baselayout />}>
              <Route index element={<Home />} />
              <Route path="about" element={<About />} />
              <Route path="product" element={<Product />} />
              <Route path="partner" element={<Partner />} />
              <Route path="inqury" element={<Inqury />} />
              <Route path="contact" element={<Contact />} />
              <Route path="csr" element={<Csr />} />
              <Route path="careers" element={<Careers />} />
              <Route path="investor" element={<Investor />} />
              <Route path="faq" element={<Faq />} />
              <Route path="privacynotice" element={<PrivacyNotice />} />
              <Route path="cookiepolicy" element={<CookiePolicy />} />
              <Route path="accessibility" element={<Accessibility />} />
              <Route path="disclaimer" element={<Disclaimer />} />
              <Route path="securitypolicy" element={<SecurityPolicy />} />
              <Route path="californianotice" element={<CaliforniaNotice />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;



// import React from 'react';
// import {
//   BrowserRouter,
//   Route,
//   Routes,
//   Outlet,
// } from "react-router-dom";
// import { HelmetProvider } from 'react-helmet-async';
// import Home from './component/pages/home/Home';
// import Header from './component/header/Header';
// import Footer from './component/footer/Footer';
// import Upheader from './component/upheader/Upheader';
// import Product from './component/pages/our-product/Product';
// import About from './component/pages/about/About';
// import Partner from './component/partners/Partner';
// import Inqury from './component/pages/inqury/Inqury';
// import Contact from './component/pages/contact/Contact';
// import ScheduleMeeting from './component/schedulemeetingmeeting/ScheduleMeeting';
// import WhatsAppChat from './component/whatsAppchat/WhatsAppChat';
// import Clint from './component/clint/Clint';
// import Csr from './component/quick/Csr';
// import Careers from './component/quick/Careers';
// import Investor from './component/quick/Investor';
// import Fq from './component/quick/Fq';
// import PrivacyNotice from './component/quick/Privacy';
// import CookiePolicy from './component/quick/Cookie';
// import Accessibility from './component/quick/Accessibility';
// import Disclaimer from './component/quick/Disclaimer';
// import SecurityPolicy from './component/quick/Security';
// import CaliforniaNotice from './component/quick/California';





// function App() {
//   return (
//     <HelmetProvider>
//       <BrowserRouter>
//         <Routes>
//           <Route path='/' element={<Baselayout />}>
//             <Route index element={<Home />} />
//             <Route path='about' element={<About />} />
//             <Route path='product' element={<Product />} />
//             <Route path='partner' element={<Partner />} />
//             <Route path='inqury' element={<Inqury />} />
//             <Route path='contact' element={<Contact />} />
//             <Route path='Csr' element={<Csr />} />
//             <Route path='careers' element={<Careers />} />
//             <Route path='Investor' element={<Investor />} />
//             <Route path='fq' element={<Fq />} />
//             <Route path='ScheduleMeeting' element={<ScheduleMeeting />} />
//             <Route path="/PrivacyNotice" element={<PrivacyNotice />} />
//             <Route path="/CookiePolicy" element={<CookiePolicy />} />
//             <Route path="/Accessibility" element={<Accessibility />} />
//             <Route path="/Disclaimer" element={<Disclaimer />} />
//             <Route path="/SecurityPolicy" element={<SecurityPolicy />} />
//             <Route path="/CaliforniaNotice" element={<CaliforniaNotice />} />

//           </Route>
//         </Routes>
//       </BrowserRouter>
//     </HelmetProvider>

//   );
// }

// export default App;



// const Baselayout = () => {
//   return (
//     <>
//       <Upheader />
//       <Header />
//       <ScheduleMeeting />
//       <WhatsAppChat />
//       <Outlet />
//       <Clint />
//       <Footer />
//     </>
//   )
// }






